var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',[_c('div',{staticClass:"margin-payment-detail"},[_c('project-info-panel',{attrs:{"card-bordered":false,"workflow-apply-record-id":_vm.workflowApplyRecordId}}),_c('fixed-deposit-panel',{attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }